import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './app/App';
import reportWebVitals from './reportWebVitals';

// Silence console output in production unless debug mode is enabled
// Enable via: ?debug=true in URL or localStorage.setItem('debug', 'true')
const debugEnabled =
  window.location.search.includes('debug=true') ||
  localStorage.getItem('debug') === 'true';

if (process.env.NODE_ENV !== 'development' && !debugEnabled) {
  const noop = () => {};
  [
    'log',
    'debug',
    'info',
    'warn',
    'trace',
    'group',
    'groupCollapsed',
    'groupEnd',
  ].forEach(method => {
    // @ts-ignore – dynamic assignment is intentional
    console[method] = noop;
  });
  // Keep console.error for critical issues
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <App />
);

reportWebVitals();
